<template>
  <v-select
    v-model="mutableSelected"
    class="vSelectDropDownText disableClear"
    :options="rangeOptions"
    :select-on-tab="true"
  />
</template>
<script>
  import VSelect from "vue-select"

  export default {
    name: "DateRangeSelect",
    components: { VSelect },
    props: {
      selected: {
        type: Object,
        default () {
          return { label: "All Dates", value: 0 }
        }
      },
      rangeOptions: {
        type: Array,
        default () {
          return [
            { label: "All Dates", value: 0 },
            { label: "Last 30 Days", value: 30 },
            { label: "Last 60 Days", value: 60 },
            { label: "Last 90 Days", value: 90 },
            { label: "Last Year", value: 365 },
            { label: "Last 2 Years", value: 720 }
          ]
        }
      }
    },
    computed: {
      mutableSelected: {
        // TODO: This may be overkill for the purpose of simple binding
        get () {
          return this.selected
        },
        set (val) {
          this.$emit("update:selected", val)
        }
      }
    }
  }
</script>
